import '../style.scss'
import { useContext, useEffect, useState } from "react";
import { 
    AppSpan, Button, CenterPopupContainer, CheckBox, 
    CustomContainer, FixedContainer, FlexRow, Form, FormGroup, ScreenTitle 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { NewUserLayout } from 'src/component'
import { MdCheck } from 'react-icons/md'
import { UserType } from 'src/model';
import { useNotifier } from "react-pop-notifier"

export const NewUserBasics: React.FC<any> = ({next, selectedUser, close}) => {
    const {notifier} = useNotifier()
    const {info: {userCreationProcess, userType}, setInfoProperty} = useContext(AppInfoContext)
    const [currentUserType, setCurrentUserType] = useState(userType)
    const [input, setInput] = useState({
        firstName: '', lastName: '', phoneNumber: '', email: '',
        password: '', confirmPassword: '', city: '',
        //username: '', maritalStatus: '', 
        shouldChangePassword: false, shouldSendPassword: false,
    })

    useEffect(() => {
        if (userType) setCurrentUserType(userType)
    }, [userType]) 

    useEffect(() => {
        const existingData = userCreationProcess?.email ? userCreationProcess : selectedUser

        if (existingData) {
            const {firstName, lastName, phoneNumber, email, city} = existingData
            setInput({
                ...input, 
                firstName, 
                lastName, 
                phoneNumber, 
                email,
                city
            }) 
        }
    }, [selectedUser, userCreationProcess])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleNext(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (currentUserType === UserType.ADMIN && (input.password != input.confirmPassword)) {
            return notifier.show('Password mismatch', 'Validation Response')
        }

        await setInfoProperty('userCreationProcess', {...userCreationProcess, ...input, userBasics: true})
        next()
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewUserLayout currentScreen='user-basics'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Set Up basics for the User
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='3' onSubmit={handleNext}>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>First Name</label>
                                <input 
                                    placeholder='Enter First Name' 
                                    name='firstName'
                                    value={input.firstName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Last Name</label>
                                <input 
                                    placeholder='Enter Last Name' 
                                    name='lastName'
                                    value={input.lastName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Email</label>
                                <input 
                                    placeholder='Enter Email' 
                                    name='email'
                                    value={input.email}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Phone Number</label>
                                <input 
                                    placeholder='Enter Phone Number' 
                                    name='phoneNumber'
                                    value={input.phoneNumber}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        {/* <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Username</label>
                                <input 
                                    placeholder='Enter Username' 
                                    name='username'
                                    value={input.username}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Marital Status</label>
                                <input 
                                    placeholder='Enter Marital Status' 
                                    name='maritalStatus'
                                    value={input.maritalStatus}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        </FlexRow> */}
                        { currentUserType === UserType.ADMIN &&
                            <>
                                <FlexRow 
                                    justifyContent='space-between' gap='2'
                                    className='user-basic-input-row'
                                >
                                    <FormGroup bottomMargin='0'>
                                        <label>Password</label>
                                        <input 
                                            placeholder='Enter Password' 
                                            name='password'
                                            type='password'
                                            value={input.password}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup bottomMargin='0'>
                                        <label>Confirm Password</label>
                                        <input 
                                            placeholder='Enter Password' 
                                            name='confirmPassword'
                                            type='password'
                                            value={input.confirmPassword}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                </FlexRow>
                                <FlexRow 
                                    justifyContent='space-between' gap='2'
                                    className='user-basic-input-row'
                                >
                                    <FormGroup bottomMargin='0'>
                                        <label>City</label>
                                        <input 
                                            placeholder='Enter City' 
                                            name='city'
                                            value={input.city}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                </FlexRow>
                            </>
                        }

                        <FlexRow gap='1' bottomMargin='1.5' topMargin='4'>
                            <CheckBox
                                bgColor={input.shouldSendPassword ? '#5627FF' : 'transparent'}
                                borderColor={input.shouldSendPassword ? '#5627FF' : '#828282'}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                onClick={() => setInput({...input, shouldSendPassword: !input.shouldSendPassword})}
                            >
                                { input.shouldSendPassword &&
                                    <MdCheck
                                        color='#ffffff' fontSize='1.8rem' 
                                    />
                                }
                            </CheckBox>
                            <AppSpan textSize='1.6' color='#111111'>
                                Send Password and login details to user via email.
                            </AppSpan>
                        </FlexRow>
                        <FlexRow gap='1'>
                            <CheckBox
                                bgColor={input.shouldChangePassword ? '#5627FF' : 'transparent'}
                                borderColor={input.shouldChangePassword ? '#5627FF' : '#828282'}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                onClick={() => setInput({...input, shouldChangePassword: !input.shouldChangePassword})}
                            >
                                { input.shouldChangePassword &&
                                    <MdCheck
                                        color='#ffffff' fontSize='1.8rem' 
                                    />
                                }
                            </CheckBox>
                            <AppSpan textSize='1.6' color='#111111'>
                                Require user to change password upon login.
                            </AppSpan>
                        </FlexRow>

                        <FlexRow 
                            justifyContent='flex-end'
                            gap="1" topMargin='5'
                        >
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff'
                                bgColor="#ffffff" 
                                hoverBorderColor='#5627FF'
                                hoverColor='#5627FF'
                                color="#5627FF"
                                onClick={close}
                            >
                                Back
                            </Button>
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Next
                            </Button>
                        </FlexRow>
                    </Form>
                </NewUserLayout>
            </FixedContainer>
        </>
    )
}